import StackController from './stack.controller';
import { IStack } from './stack.model';

const Stack = (props: IStack) => {
  return <StackController {...props} />;
};

export default Stack;
